import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import SvgIcon from '@material-ui/core/SvgIcon';
import InfiniteScroll from 'react-infinite-scroll-component';
import CircularLoader from '../../../../components/circularLoader/CircularLoader';
import {SearchState} from '../../../../constants/enums';
import LibraryTrack from './LibraryTrack';
import iconUpload from '../../../../assets/images/studio/upload';
import FileAttach from '../../../../components/FileAttach';

@inject('dialogStore', 'trackStore', 'searchStore', 'uploadTrackStore')
@observer
class UploadsContainer extends Component {

    componentDidMount() {
        this.props.searchStore.fetchItems(SearchState.myUploads);
    }

    handleLoadMore = () => {
        this.props.searchStore.fetchItems(SearchState.myUploads);
    };

    handleFileChange = (target) => {
        this.props.uploadTrackStore.onFileChange('file', target[0].name, target);
        this.props.dialogStore.openUploadDialog();
    };

    render() {
        const {trackStore, isTrackAdded, playTrack, addTrack, removeTrack} = this.props;
        const hasMoreItems = trackStore.isFetching || (trackStore.ownedTracksPageCount === 0 && trackStore.uploadedTracks.length) || trackStore.ownedTracksPageCount > trackStore.ownedTracksCurrentPage;

        return (
            <div className="m-studio-uploads">
                <FileAttach onChange={this.handleFileChange} fileExtension='audio/*, video/mp4, .wma'>
                    <button className="m-studio-btn">
                        <div className="icon"><SvgIcon viewBox="0 0 36 36">{iconUpload}</SvgIcon></div>
                        <div className="name"><FormattedMessage id="studio.library.upload"/></div>
                    </button>
                </FileAttach>
                <InfiniteScroll
                    scrollableTarget="library-modal"
                    scrollThreshold="70px"
                    className="infinite-content"
                    dataLength={trackStore.uploadedTracks.length}
                    next={this.handleLoadMore}
                    hasMore={hasMoreItems}
                    loader={<CircularLoader />}>
                    {trackStore.uploadedTracks.map(track => (
                        <LibraryTrack
                            key={track.id}
                            track={track}
                            isTrackAdded={isTrackAdded(track.id)}
                            playTrack={playTrack(track)}
                            addTrack={addTrack(track)}
                            removeTrack={removeTrack(track)}
                        />
                    ))}
                </InfiniteScroll>
            </div>
        );
    }
}

export default UploadsContainer;
